import smoothscroll from 'smoothscroll-polyfill';

import './sorting';
import './filtering';
import './floor-plan';
import './slider-workaround';
import './lightbox';

smoothscroll.polyfill();

function scrollToElement(element) {
  const rect = element.getBoundingClientRect();
  const top = window.scrollY + rect.top + Math.min(
    - 100,
    rect.height / 2 - window.innerHeight / 2
  );

  window.scrollTo({ top, behavior: 'smooth' });
}


document.addEventListener('click', event => {
  const linkElement = event.target.closest('a');
  if (linkElement === null) return;

  if (
    linkElement.origin.replace(/https?/, '') !== window.location.origin.replace(/https?/, '') ||
    linkElement.pathname.replace(/\/$/, '') !== window.location.pathname.replace(/\/$/, '')
  ) return;

  const anchor = linkElement.hash;
  if (!anchor) return;
  const anchorElement = document.querySelector(anchor);
  if (anchorElement === null) return;

  event.preventDefault();
  scrollToElement(anchorElement);
});


// redirect contact form after submission
document.addEventListener('wpcf7mailsent', function (event) {
  if (event.detail.contactFormId === 1964) return;

  setTimeout(() => {
    document.location = formThankYouPageUrl;
  }, 1000);
}, false);


// scroll to contact button
const contactForm = document.querySelector('.wpcf7[data-wpcf7-id="1585"], .wpcf7[data-wpcf7-id="143"]');
const contactScrollButton = document.querySelector('#contact-scroll');

if (contactForm && contactScrollButton) {
  contactScrollButton.style.display = "block";
  contactScrollButton.addEventListener('click', () => scrollToElement(contactForm));
}
